import CreateNewDataset from './CreateNewDataset';

export default {
	routeProps: {
		path: '/create-new-dataset',
		component: CreateNewDataset,
	},
	name: 'CreateNewDataset',
};
